import React from 'react';
import { Avatar } from '../../components/Avatar/Avatar';

/**
 * UserAvatar — wrap Avatar pour un objet User typé du portfolio.
 * Gère prioritairement avatarUrl, sinon initiales depuis name/email.
 */
export function UserAvatar({ user, size = 'md', shape = 'circle', className, ...rest }) {
  const name = user?.name || user?.email || 'Utilisateur';
  return (
    <Avatar
      src={user?.avatarUrl}
      name={name}
      alt={name}
      size={size}
      shape={shape}
      className={className}
      {...rest}
    />
  );
}

export default UserAvatar;
